import * as React from "react";
import { Ordering } from "@/types/base";
import { ChevronDown, ChevronUp } from "lucide-react";

interface Props {
  setOrdering: (ordering: Ordering) => void;
  ordering: Ordering;
}
export const SnapshotCollectionsOutcomesHeader: React.FC<Props> = ({ setOrdering, ordering }) => {
  const handleClick = (field: string) => {
    setOrdering({ ...ordering, order_by: field, descending: !ordering.descending });
  };

  return (
    <thead className="bg-gray-50">
      <tr>
        <th
          scope="col"
          className="cursor-pointer py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
          onClick={() => handleClick("name")}
        >
          <div className="flex items-center">
            Snapshot name
            {ordering.order_by === "name" ? (
              ordering.descending ? (
                <ChevronDown className="ml-1 h-4 w-4" />
              ) : (
                <ChevronUp className="ml-1 h-4 w-4" />
              )
            ) : (
              <ChevronUp className="ml-1 h-4 w-4 text-gray-400" />
            )}
          </div>
        </th>

        <th
          scope="col"
          className="cursor-pointer px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
          onClick={() => handleClick("created_at")}
        >
          <div className="flex items-center">
            Created
            {ordering.order_by === "created_at" ? (
              ordering.descending ? (
                <ChevronDown className="ml-1 h-4 w-4" />
              ) : (
                <ChevronUp className="ml-1 h-4 w-4" />
              )
            ) : (
              <ChevronUp className="ml-1 h-4 w-4 text-gray-400" />
            )}
          </div>
        </th>
        <th
          scope="col"
          className="cursor-pointer px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
          onClick={() => handleClick("status")}
        >
          <div className="flex items-center">
            Status
            {ordering.order_by === "status" ? (
              ordering.descending ? (
                <ChevronDown className="ml-1 h-4 w-4" />
              ) : (
                <ChevronUp className="ml-1 h-4 w-4" />
              )
            ) : (
              <ChevronUp className="ml-1 h-4 w-4 text-gray-400" />
            )}
          </div>
        </th>
        <th
          scope="col"
          className="cursor-pointer px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
          onClick={() => handleClick("verified")}
        >
          <div className="flex items-center">
            Verified
            {ordering.order_by === "verified" ? (
              ordering.descending ? (
                <ChevronDown className="ml-1 h-4 w-4" />
              ) : (
                <ChevronUp className="ml-1 h-4 w-4" />
              )
            ) : (
              <ChevronUp className="ml-1 h-4 w-4 text-gray-400" />
            )}
          </div>
        </th>
        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
          <span className="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
  );
};
